import { defineStore } from 'pinia'

export const useAppStore = defineStore('app', () => {
  /**
   * Don't toggle loadingBarClass directly.
   * Use startLoad, endLoad functions instead to ensure proper animation.
   */
  const loadingBarClass = ref<'is-loading' | 'is-done' | ''>('')
  function startBarLoad() {
    loadingBarClass.value = 'is-loading'
  }
  function endBarLoad() {
    loadingBarClass.value = 'is-done'
    setTimeout(() => {
      loadingBarClass.value = ''
    }, 200)
  }

  return {
    startBarLoad,
    endBarLoad,
    loadingBarClass,
  }
})
